import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const JoinGroupPage = () => {
  const { encryptedId } = useParams(); // Récupère l'identifiant crypté de l'URL
  const navigate = useNavigate();
  const [groupInfo, setGroupInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Charger les informations du groupe
    const fetchGroupInfo = async () => {
      try {
        const response = await axios.get(`/api/groups/join/${encryptedId}`);
        setGroupInfo(response.data);
        setLoading(false);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des informations du groupe :",
          error
        );
        alert("Lien invalide ou expiré.");
        navigate("/"); // Redirection en cas d'erreur
      }
    };

    fetchGroupInfo();
  }, [encryptedId, navigate]);

  const handleJoinRequest = async () => {
    try {
      await axios.post(`/api/groups/join/${encryptedId}`, { userId: 1 }); // Remplacez `1` par l'ID utilisateur connecté
      alert("Votre demande a été envoyée au coach.");
      navigate("/");
    } catch (error) {
      console.error("Erreur lors de l'envoi de la demande :", error);
      alert("Impossible d'envoyer la demande. Veuillez réessayer.");
    }
  };

  if (loading) {
    return <p>Chargement...</p>;
  }

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 border rounded-lg shadow-md">
      <h1 className="text-xl font-bold mb-4">Rejoindre le groupe</h1>
      <p className="mb-2">Groupe : {groupInfo.groupName}</p>
      <p className="mb-4">Coach : {groupInfo.coachName}</p>
      <div className="flex space-x-4">
        <button
          onClick={handleJoinRequest}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Oui, je veux rejoindre
        </button>
        <button
          onClick={() => navigate("/")}
          className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
        >
          Non, retour
        </button>
      </div>
    </div>
  );
};

export default JoinGroupPage;
